import React from "react";
import closePng from './../assets/deletePlan.png';
import Skeleton from "@material-ui/lab/Skeleton";

const UNSELECTED_COLOR = '#99E1FF';
const SELECTED_COLOR = '#CCF0FF';

const styles = {
    tab: {
        padding: '6px 18px 3px'
    },
    tabWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        borderTopRightRadius: 30,
        borderTopLeftRadius: 5
    }
};

class Tab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCurrentPlan: props.isCurrentPlan,
            isLoading: props.isLoading
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.isCurrentPlan !== this.props.isCurrentPlan || prevProps.isLoading !== this.props.isLoading) {
            this.setState({ isCurrentPlan: this.props.isCurrentPlan, isLoading: this.props.isLoading })
        }
    }

    render() {
        const BACKGROUND_COLOR = this.state.isCurrentPlan ? SELECTED_COLOR : UNSELECTED_COLOR;
        return (
            <div style={{ ...styles.tabWrapper, backgroundColor: BACKGROUND_COLOR }}>
                {
                    this.state.isCurrentPlan
                        && <div
                                style={{ marginTop: 3, marginLeft: 3, height: 28, display: 'flex', flexDirection: 'column' }}>
                            <img onClick={ this.props.openDeletePlanPopup } style={{width: 6, height: 6}} src={closePng} />
                        </div>
                }
                {
                    this.state.isLoading
                        ? <div style={{ ...styles.tab, paddingLeft: this.props.isFirst ? 2 : 10 }}>
                            <Skeleton variant={"rect"} width={31} height={18} />
                        </div>
                        : <div style={{ ...styles.tab, paddingLeft: this.state.isCurrentPlan ? 2 : 10 }}
                              onClick={ () => { this.props.onSwitchPlan(this.props.id) } }>
                            { this.props.name }
                        </div>
                }
            </div>
        );
    }
}

export default Tab;